import React from 'react';
import PropTypes from 'prop-types';
import { StyledIconContainer, StyledIcon, StyledIconCounter } from './style';

const IconCounter = props => {
  const Tabindex = props.hover ? '0' : '-1';
  const Role = props.hover ? 'button' : '';
  return (
    <StyledIconContainer counter={props.counter}>
      <StyledIcon
        className={props.className}
        color={props.color}
        id={props.id}
        size={props.size}
        svg={props.svg}
        onClick={props.onClick}
        tabIndex={Tabindex}
        role={Role}
        expanded={props.expanded}
        haspopup={props.haspopup}
        hover={props.hover}
        width={props.width}
        height={props.height}
      />
      {props.counter > 0 && (
        <StyledIconCounter counter={props.counter}>
          {props.counter}
        </StyledIconCounter>
      )}
    </StyledIconContainer>
  );
};

IconCounter.propTypes = {
  className: PropTypes.string,
  color: PropTypes.oneOf([
    'primary',
    'secondary',
    'dark',
    'grayDark',
    'grayDarker',
    'light',
    'error',
    'success',
    'main'
  ]),
  hover: PropTypes.bool,
  size: PropTypes.oneOf(['xxs', 'xs', 's', 'sm', 'smm', 'm', 'l', 'xl']),
  svg: PropTypes.shape({
    viewBox: PropTypes.string,
    url: PropTypes.string
  }).isRequired,
  onClick: PropTypes.func,
  id: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  counter: PropTypes.number
};

IconCounter.defaultProps = {
  color: 'dark',
  hover: false
};

export default IconCounter;
